<template>
  <nav 
    :class="[
      'tw-fixed tw-left-0 tw-border-r tw-flex tw-flex-col tw-flex-shrink-0 tw-z-[1001] tw-overflow-hidden tw-inset-auto tw-overflow-visible',
      isMobile ? 'tw-top-[50px] tw-bottom-0' : 'tw-inset-y-0',
      isMobile && isCollapsed ? 'tw-w-0' : (isMobile ? 'tw-w-72' : (isCollapsed ? 'tw-w-24' : 'tw-w-72')),
      theme === 'dark' ? 'tw-bg-[#0f1114] tw-text-gray-400 tw-border-[#1e2024]' : 'tw-bg-[#e9eef6] tw-text-gray-600 tw-border-gray-200'
    ]"
  >
    <div :class="['tw-relative tw-overflow-hidden tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-shrink-0', isCollapsed ? 'tw-h-32' : 'tw-h-44 tw-p-5 tw-mb-2']">
      <template v-if="!isCollapsed">
        <img :src="getImageUrl(unidade.imagem)" class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-opacity-30" alt="Imagem Unidade" />
        <div :class="['tw-absolute tw-inset-0 tw-bg-gradient-to-t tw-to-transparent', theme === 'dark' ? 'tw-from-[#0f1114] tw-via-[#0f1114]/40' : 'tw-from-[#e9eef6] tw-via-[#e9eef6]/30']"></div>
      </template>

        <div class="tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-space-y-3">
          <div :class="[
            'tw-rounded-2xl tw-p-0.5 tw-shadow-2xl',
            isActive('UnidadeDetailsPage') ? 'tw-ring-[#33b35a]' : 'tw-ring-transparent',
            isCollapsed ? 'tw-w-10 tw-h-10' : 'tw-w-20 tw-h-20'
          ]">
          <img :src="getImageUrl(unidade.logo)" class="tw-bg-white tw-w-full tw-h-full tw-rounded-[14px] tw-object-cover shadow-inner" alt="Logo" />
        </div>
        <div v-if="!isCollapsed" class="tw-text-center">
          <h2 :class="['tw-font-bold tw-text-sm tw-tracking-wide tw-uppercase tw-line-clamp-1', theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-800']">
            {{ unidade.nome }}
          </h2>
        </div>
      </div>
    </div>

    <div :class="!isCollapsed ? 'tw-px-3 tw-py-4' : ''" class="tw-flex-1 tw-overflow-y-auto custom-scrollbar tw-flex tw-flex-col">
      <div>
        <span v-if="!isCollapsed" :class="['tw-text-[10px] tw-font-black tw-tracking-[0.25em] tw-uppercase tw-px-4 tw-mb-4 tw-block', theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-400']">
          Inteligência
        </span>
        
        <ul :class="['tw-space-y-2', isCollapsed ? 'tw-flex tw-flex-col tw-items-center' : '']">
          
          <li v-if="isAdmin" class="tw-w-full">
            <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id + '/winckieel-intelligence'" :class="linkClass('WinckieelIntelligencePage')">
              <svg :class="optionIconClass('WinckieelIntelligencePage')" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 3C12 7.97056 16.0294 12 21 12C16.0294 12 12 16.0294 12 21C12 16.0294 7.97056 12 3 12C7.97056 12 12 7.97056 12 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              <span :class="optionTextClass('WinckieelIntelligencePage')">Winckieel IA</span>
            </router-link>
          </li>

          <li class="tw-w-full">
            <router-link :to="'/v2/consulta-avancada'" :class="linkClass('ConsultaAvancadaPage')">
              <svg :class="optionIconClass('ConsultaAvancadaPage')" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              <span :class="optionTextClass('ConsultaAvancadaPage')">Consulta Avançada</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="tw-mt-8">
        <span v-if="!isCollapsed" :class="['tw-text-[10px] tw-font-black tw-tracking-[0.25em] tw-uppercase tw-px-4 tw-mb-4 tw-block', theme === 'dark' ? 'tw-text-gray-400' : 'tw-text-gray-400']">
          Menu Principal
        </span>
        
        <ul :class="['tw-space-y-2', isCollapsed ? 'tw-flex tw-flex-col tw-items-center' : '']">
          <li class="tw-w-full">
            <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id" :class="linkClass('UnidadeDetailsPage')">
              <svg :class="optionIconClass('UnidadeDetailsPage')" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6139 1.21065C12.2528 0.929784 11.7472 0.929784 11.3861 1.21065L2.38606 8.21065C2.14247 8.4001 2 8.69141 2 9V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9C22 8.69141 21.8575 8.4001 21.6139 8.21065L12.6139 1.21065ZM16 20H20V9.48908L12 3.26686L4 9.48908V20H8V12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V20ZM10 20V13H14V20H10Z" fill="currentColor"></path> </g></svg>
              <span :class="optionTextClass('UnidadeDetailsPage')">Início</span>
            </router-link>
          </li>

          <li class="tw-w-full">
            <button @click="toggleDropdown('silos')" :class="dropdownBtnClass(isActive('SiloDetailsPage'))">
              <svg :class="optionIconClass('SiloDetailsPage')" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M8.5,2C11.85,2 14.6,4.53 14.96,7.78L22,12V14L20,12.8V22H18V11.6L15,9.8V22H13V9H4V22H2V8.5A6.5,6.5 0 0,1 8.5,2M8.5,4C6.54,4 4.87,5.25 4.26,7H12.74C12.13,5.25 10.46,4 8.5,4M6,11H11V13H6V11M6,15H11V17H6V15M6,19H11V21H6V19Z"></path></g></svg>
              <span :class="optionTextClass('SiloDetailsPage')">Silos</span>
              <i class="fa-solid fa-chevron-right tw-transition-transform" 
                 :class="[isCollapsed ? 'tw-text-[7px] tw-mt-1' : 'tw-text-[9px]', {'tw-rotate-90': openDropdown === 'silos'}]"></i>
            </button>
            
            <div v-if="openDropdown === 'silos'" :class="dropdownContainerClass">
              <router-link @click="adjustSidebarMobile" v-for="silo in silos" :key="silo.id" :to="'/v2/unidades/'+ silo.unidade_id +'/silos/' + silo.id"
                :class="subLinkClass(isActive('/v2/unidades/' + unidade.id + '/silos/' + silo.id))">
                {{ silo.nome }}
              </router-link>
            </div>
          </li>

          <li class="tw-w-full">
            <button @click="toggleDropdown('reports')" :class="dropdownBtnClass(isActive('RelatorioTermometriaPage') || isActive('RelatorioAeracaoPage') || isActive('RelatorioEstacaoPage') || isActive('RelatorioLogsPage'))">
              <svg :class="optionIconClass(['RelatorioTermometriaPage', 'RelatorioAeracaoPage', 'RelatorioEstacaoPage', 'RelatorioLogsPage'])" fill="currentColor" viewBox="0 0 1000 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 1000 1000" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata> <g> <g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)"> <path d="M1685.8,4989.2c-253.7-58.9-499.3-265.9-621.1-519.6l-75.1-158.3l-6.1-4141c-4.1-2772.8,2-4173.4,16.2-4238.4c56.8-267.9,257.8-513.6,523.7-639.4l156.3-75.1l3258-6.1c2174-4.1,3290.4,2,3355.4,16.2c326.8,69,627.2,365.4,702.4,692.2c14.2,58.9,22.3,1049.5,22.3,2809.4c0,2616.5-2,2724.1-38.6,2801.2c-48.7,101.5-3373.6,3428.5-3458.9,3460.9C5449.2,5017.6,1797.5,5015.6,1685.8,4989.2z M4856.5,3087.2c0-1433.1,2-1451.4,115.7-1648.3c89.3-152.2,253.7-298.4,426.3-381.6l158.3-75.1l1427-6.1l1425-6.1v-2494.7c0-1891.9-6.1-2506.9-24.4-2547.5c-52.8-117.7,148.2-111.6-3385.8-111.6s-3333.1-6.1-3385.8,111.6c-38.6,81.2-34.5,8302.2,4.1,8371.2c58.9,105.6,12.2,101.5,1682.8,103.5h1556.9V3087.2z M6866.1,1585.1c-1351.9-4.1-1337.7-6.1-1380.3,109.6c-12.2,30.5-20.3,552.1-20.3,1293V4230l1319.4-1319.4l1319.4-1319.4L6866.1,1585.1z"></path> <path d="M2989-327.1v-304.5h2009.6h2009.6v304.5v304.5H4998.6H2989V-327.1z"></path> <path d="M2989-1646.5V-1951h2009.6h2009.6v304.5v304.5H4998.6H2989V-1646.5z"></path> <path d="M2989-2925.3v-304.5h954.1h954v304.5v304.5h-954H2989V-2925.3z"></path> </g> </g> </g></svg>
              <span :class="optionTextClass(['RelatorioTermometriaPage', 'RelatorioAeracaoPage', 'RelatorioEstacaoPage', 'RelatorioLogsPage'])">Relatórios</span>
              <i class="fa-solid fa-chevron-right tw-transition-transform" 
                 :class="[isCollapsed ? 'tw-text-[7px] tw-mt-1' : 'tw-text-[9px]', {'tw-rotate-90': openDropdown === 'reports'}]"></i>
            </button>
            <div v-if="openDropdown === 'reports'" :class="dropdownContainerClass">
              <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id + '/relatorios/silos/termometria'" :class="subLinkClass(isActive('RelatorioTermometriaPage'))">Termometria</router-link>
              <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id + '/relatorios/silos/aeracao'" :class="subLinkClass(isActive('RelatorioAeracaoPage'))">Aeração</router-link>
              <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id + '/relatorios/estacao'" :class="subLinkClass(isActive('RelatorioEstacaoPage'))">Meteorológico</router-link>
              <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id + '/relatorios/logs'" :class="subLinkClass(isActive('RelatorioLogsPage'))">Logs</router-link>
            </div>
          </li>
        </ul>
      </div>
      <div class="tw-mt-8">
        <span v-if="!isCollapsed" class="tw-text-[10px] tw-font-black tw-tracking-[0.25em] tw-text-gray-400 tw-uppercase tw-px-4 tw-mb-4 tw-block">
          Operacional
        </span>
        
        <ul :class="['tw-space-y-2', isCollapsed ? 'tw-flex tw-flex-col tw-items-center' : '']">
          <li class="tw-w-full">
            <button @click="toggleDropdown('leituras')" :class="dropdownBtnClass(isActive('LeiturasAutomaticasPage') || isActive('AddLeiturasPage'))">
              <svg :class="optionIconClass(['LeiturasAutomaticasPage', 'AddLeiturasPage'])" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 7V12L9.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              <span :class="optionTextClass(['LeiturasAutomaticasPage', 'AddLeiturasPage' ])">Leituras</span>
              <i class="fa-solid fa-chevron-right tw-transition-transform" 
                 :class="[isCollapsed ? 'tw-text-[7px] tw-mt-1' : 'tw-text-[9px]', {'tw-rotate-90': openDropdown === 'leituras'}]"></i>
            </button>
            <div v-if="openDropdown === 'leituras'" :class="dropdownContainerClass">
              <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/'+unidade.id+'/leituras/leituras-automaticas'" :class="subLinkClass(isActive('LeiturasAutomaticasPage'))">Automáticas</router-link>
              <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/'+unidade.id+'/leituras/adicionar'" :class="subLinkClass(isActive('AddLeiturasPage'))">Upload</router-link>
            </div>
          </li>

          <li class="tw-w-full">
            <router-link @click="adjustSidebarMobile" :to="'/v2/unidades/' + unidade.id + '/configuracoes/aeracao'" :class="linkClass('AeracaoPage')">
              <svg :class="optionIconClass('AeracaoPage')" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19.5 12C18.1193 12 17 10.8807 17 9.5C17 8.11929 18.1193 7 19.5 7M19.5 12C20.8807 12 22 10.8807 22 9.5C22 8.11929 20.8807 7 19.5 7M19.5 12V21M19.5 7V3M12 18.9998C10.6193 18.9998 9.5 17.8805 9.5 16.4998C9.5 15.1191 10.6193 13.9998 12 13.9998M12 18.9998C13.3807 18.9998 14.5 17.8805 14.5 16.4998C14.5 15.1191 13.3807 13.9998 12 13.9998M12 18.9998V20.9996M12 13.9998V3.00012M4.5 10C3.11929 10 2 8.88071 2 7.5C2 6.11929 3.11929 5 4.5 5M4.5 10C5.88071 10 7 8.88071 7 7.5C7 6.11929 5.88071 5 4.5 5M4.5 10V21M4.5 5V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              <span :class="optionTextClass('AeracaoPage')">Aeração</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div :class="[
      'tw-border-t tw-relative tw-overflow-hidden tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-shrink-0 tw-mb-2',
      theme.value === 'dark' ? 'tw-border-gray-800' : 'tw-border-gray-400',
      isMobile && isCollapsed ? 'tw-p-0' : 'tw-p-2']"
    >
      <button class="tw-w-full tw-mt-auto" @click="authLogout" :class="linkClass('LoginPage')">
        <svg :class="optionIconClass('LoginPage')" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12.9999 2C10.2385 2 7.99991 4.23858 7.99991 7C7.99991 7.55228 8.44762 8 8.99991 8C9.55219 8 9.99991 7.55228 9.99991 7C9.99991 5.34315 11.3431 4 12.9999 4H16.9999C18.6568 4 19.9999 5.34315 19.9999 7V17C19.9999 18.6569 18.6568 20 16.9999 20H12.9999C11.3431 20 9.99991 18.6569 9.99991 17C9.99991 16.4477 9.55219 16 8.99991 16C8.44762 16 7.99991 16.4477 7.99991 17C7.99991 19.7614 10.2385 22 12.9999 22H16.9999C19.7613 22 21.9999 19.7614 21.9999 17V7C21.9999 4.23858 19.7613 2 16.9999 2H12.9999Z" fill="currentColor"></path> <path d="M13.9999 11C14.5522 11 14.9999 11.4477 14.9999 12C14.9999 12.5523 14.5522 13 13.9999 13V11Z" fill="#000000"></path> <path d="M5.71783 11C5.80685 10.8902 5.89214 10.7837 5.97282 10.682C6.21831 10.3723 6.42615 10.1004 6.57291 9.90549C6.64636 9.80795 6.70468 9.72946 6.74495 9.67492L6.79152 9.61162L6.804 9.59454L6.80842 9.58848C6.80846 9.58842 6.80892 9.58778 5.99991 9L6.80842 9.58848C7.13304 9.14167 7.0345 8.51561 6.58769 8.19098C6.14091 7.86637 5.51558 7.9654 5.19094 8.41215L5.18812 8.41602L5.17788 8.43002L5.13612 8.48679C5.09918 8.53682 5.04456 8.61033 4.97516 8.7025C4.83623 8.88702 4.63874 9.14542 4.40567 9.43937C3.93443 10.0337 3.33759 10.7481 2.7928 11.2929L2.08569 12L2.7928 12.7071C3.33759 13.2519 3.93443 13.9663 4.40567 14.5606C4.63874 14.8546 4.83623 15.113 4.97516 15.2975C5.04456 15.3897 5.09918 15.4632 5.13612 15.5132L5.17788 15.57L5.18812 15.584L5.19045 15.5872C5.51509 16.0339 6.14091 16.1336 6.58769 15.809C7.0345 15.4844 7.13355 14.859 6.80892 14.4122L5.99991 15C6.80892 14.4122 6.80897 14.4123 6.80892 14.4122L6.804 14.4055L6.79152 14.3884L6.74495 14.3251C6.70468 14.2705 6.64636 14.1921 6.57291 14.0945C6.42615 13.8996 6.21831 13.6277 5.97282 13.318C5.89214 13.2163 5.80685 13.1098 5.71783 13H13.9999V11H5.71783Z" fill="currentColor"></path> </g></svg>
        <span :class="optionTextClass('LoginPage')">Sair</span>
      </button>
    </div>
  </nav>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useStore, mapActions } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const silos = ref([]);
    const unidade = ref({});
    const openDropdown = ref(null);

    const theme = computed(() => store.getters['ui/theme']);
    const isAdmin = computed(() => {
      const user = store.getters['auth/getUser'];
      return user && user.tipo_usuario === 'administrador';
    });

    const adjustSidebarMobile = () => {
      if (props.isMobile) {
        store.commit('ui/TOGGLE_SIDEBAR', true);
      }
    };

    const isRelatoriosActive = computed(() => {
      const reports = ['RelatorioTermometriaPage', 'RelatorioAeracaoPage', 'RelatorioEstacaoPage', 'RelatorioLogsPage'];
      return reports.includes(route.name);
    });
    const isLeiturasActive = computed(() => {
      return route.name === 'LeiturasAutomaticasPage' || route.name === 'AddLeiturasPage';
    });
    const isSilosActive = computed(() => {
      return route.name === 'SiloDetailsPage';
    });

    const toggleDropdown = (name) => {
      openDropdown.value = openDropdown.value === name ? null : name;
    };

    watch(() => route.name, () => {
      if (isLeiturasActive.value) {
        openDropdown.value = 'leituras';
      }
      if (isRelatoriosActive.value) {
        openDropdown.value = 'reports';
      }
      if (isSilosActive.value) {
        openDropdown.value = 'silos';
      }

    }, { immediate: true });

    const isActive = (routeName) => {
      if (!routeName) return false;
      if (Array.isArray(routeName)) {
        return routeName.some(name => isActive(name));
      }
      if (routeName.startsWith('/')) return route.path === routeName;
      return route.name === routeName || route.path.includes(routeName);
    };

    const optionTextClass = (routeName) => [
      '',
      isActive(routeName) ? 'tw-text-white' : (theme.value === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'),
      props.isCollapsed ? 'tw-text-[9px] tw-uppercase tw-font-bold tw-text-center' : 'tw-text-[13px] tw-font-semibold tw-truncate tw-flex-1 tw-text-left'
    ];

    const optionIconClass = (name) => [
      'fa-lg tw-min-w-[24px] tw-max-w-[24px]',
      isActive(name) ? 'tw-text-white' : (theme.value === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'),
      props.isCollapsed ? 'tw-text-xl tw-mb-1' : 'tw-text-lg tw-mr-1'
    ];

    const linkClass = (name) => [
      'tw-flex tw-group tw-relative tw-items-center',
      props.isCollapsed ? 'tw-flex-col tw-justify-center tw-py-2 tw-px-1 tw-rounded' : 'tw-px-4 tw-py-3 tw-rounded-xl',
      isActive(name) 
        ? 'tw-bg-[#33b35a] tw-text-white tw-shadow-lg' 
        : (theme.value === 'dark' 
            ? 'hover:tw-bg-[#1e2227] hover:tw-text-white tw-text-gray-400' 
            : 'hover:tw-bg-gray-100 tw-text-gray-600 hover:tw-text-gray-900')
    ];

    const dropdownBtnClass = (active) => [
      'tw-w-full tw-flex tw-group tw-items-center',
      props.isCollapsed ? 'tw-flex-col tw-justify-center tw-py-2 tw-px-1 tw-rounded' : 'tw-px-4 tw-py-3 tw-rounded-xl',
      active 
        ? 'tw-bg-[#33b35a] tw-text-white tw-shadow-lg' 
        : (theme.value === 'dark' ? 'hover:tw-bg-[#1e2227] hover:tw-text-white tw-text-gray-400' : 'hover:tw-bg-gray-100 tw-text-gray-600')
    ];

    const dropdownContainerClass = computed(() => [
      'tw-mt-1',
      props.isCollapsed 
        ? 'tw-flex tw-flex-col tw-rounded' 
        : 'tw-ml-5 tw-border-l ' + (theme.value === 'dark' ? 'tw-border-gray-800' : 'tw-border-gray-200')
    ]);

    const subLinkClass = (active) => [
      'tw-block tw-font-bold tw-w-full tw-truncate',
      props.isCollapsed ? 'tw-text-[12px] tw-py-1.5 tw-px-1 tw-uppercase tw-text-center' : 'tw-py-2 tw-px-6 tw-text-[12px]',
      active ? 'tw-text-[#33b35a]' : (theme.value === 'dark' ? 'tw-text-gray-400 hover:tw-text-white' : 'tw-text-gray-500 hover:tw-text-gray-800')
    ];

    watch(() => store.state.silos.silos, (n) => silos.value = n, { immediate: true });
    watch(() => store.state.unidade.unidade, (n) => unidade.value = n, { immediate: true });

    return {
      unidade, silos, isAdmin, theme,
      openDropdown, toggleDropdown, isActive, linkClass, 
      dropdownBtnClass, isRelatoriosActive, isLeiturasActive, subLinkClass, 
      dropdownContainerClass, optionIconClass, optionTextClass, adjustSidebarMobile
    };
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async authLogout() {
        try {
            await this.logout();
            this.$router.push('/login');
        } catch (error) {
            console.error('Erro ao fazer logout:', error);
        }
    },
    getImageUrl(path) {
      return path ? `${process.env.VUE_APP_SERVER}/storage/${path}` : '';
    }
  }
}
</script>
<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 2px;
}
</style>